import React from 'react';
import type { PatientTO } from '../../../../../lib';
import { FavouriteStar } from '../../../ProfileBar/components';
import { useAssignPatient } from '../../../../hooks';
import { useLoggedInUser } from '../../../../../context';

interface FavouriteFomatterProps {
  id: string;
  rowData: PatientTO;
  disabled?: boolean;
}

const FavouriteFomatter = ({
  id,
  rowData,
  disabled,
}: FavouriteFomatterProps) => {
  const { loggedInUser } = useLoggedInUser();
  const { setFavourite, loading } = useAssignPatient();
  const [favourited, setFavourited] = React.useState(
    rowData.favourite ||
      rowData.favouritedClinicians?.some(
        (clinician) => clinician.user_id === loggedInUser?.userId,
      ),
  );

  const onToggleFavourite = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (loading || disabled) return;
    const originalFavourited = favourited;
    setFavourited(!favourited);
    try {
      setFavourite(!favourited, rowData.access_token);
    } catch (error) {
      setFavourited(originalFavourited);
    }
  };

  return (
    <div
      key={id}
      className={disabled ? '' : loading ? 'cursor-wait' : 'clickable'}
      onClick={onToggleFavourite}
    >
      <FavouriteStar isFavorite={favourited} onToggleFavourite={() => {}} />
    </div>
  );
};

export default FavouriteFomatter;
